import { useIntl } from 'react-intl';

import { CardSelect } from '~/eds/src/components/CardSelect/CardSelect';

import {
  OptimizeResult,
  OptimizeResultTag,
} from '../../../../../types/optimize';
import { OPTIMIZE_OPTION_WIDTH } from '../../../constants';
import { mapTagToLabel } from '../../../utils';
import { BoostResultsOptionContent } from './BoostResultsOptionContent';

interface Props {
  results: OptimizeResult[];
  selectedOption: OptimizeResultTag;
  onSelectOption: (tag: OptimizeResultTag) => void;
}

export const BoostResultsOptions = ({
  results,
  selectedOption,
  onSelectOption,
}: Props) => {
  const intl = useIntl();
  const options = results.map((result) => {
    const { tag, isRecommended } = result;
    const option = {
      ariaLabel: tag,
      content: <BoostResultsOptionContent result={result} />,
      label: mapTagToLabel(tag, intl),
      labelVariant: 'subtitle' as const,
      value: tag,
      width: OPTIMIZE_OPTION_WIDTH,
    };

    if (isRecommended) {
      return {
        ...option,
        banner: {
          label: intl.formatMessage({
            id: 'BoostResultsOptions.recommendedLabel',
            defaultMessage: 'Recommended',
            description: 'Label for recommended optimization option',
          }),
          status: 'active' as const,
          text: intl.formatMessage({
            id: 'BoostResultsOptions.recommendedText',
            defaultMessage: 'Recommended',
            description: 'Text for recommended optimization option',
          }),
        },
      };
    }
    return option;
  });

  return (
    <CardSelect
      spacing="xl"
      direction="row"
      isMulti={false}
      name="boost-option-select"
      options={options}
      value={selectedOption}
      onChange={(result) => onSelectOption(result!)}
    />
  );
};
